<app-base-dialog sizeClass="size-35" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header [title]="title" [sluitbaar]="true" (sluiten)="dialogRef.close()"></app-dialog-header>
	</ng-template>
	<div class="content">
		<div class="row">
			<div class="row-title">
				<span>Naam</span>
				<span class="required-icon">*</span>
			</div>
			<input
				class="name-input"
				#inp
				required="true"
				type="text"
				placeholder="Typ een naam"
				(input)="naam.set(inp.value)"
				[value]="naam()"
				(keyup.enter)="close()"
				cdkFocusInitial
			/>
		</div>
		<div class="row">
			<div class="row-title">
				<span>Map</span>
			</div>
			<div class="dropdown-container">
				<app-mappen-dropdown
					[mappen]="mappen()"
					[value]="selectedMap()"
					(valueChange)="selectedMap.set($event)"
					[template]="data.template"
					(created)="voegNieuweMapToe($event)"
				></app-mappen-dropdown>
			</div>
		</div>
		<app-pagina-samenvatting [url]="url"></app-pagina-samenvatting>
	</div>
	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		<app-button [enabled]="isNotEmpty()" (clickit)="dialogRef.close(getResult())">Opslaan</app-button>
	</ng-template>
</app-base-dialog>
